import type { SearchPageBody, SearchPageParams } from "@apptus/esales-api";
import elevateClient from "@server/elevate";
import type { Loop54Content } from "@server/utils/parseLoop/types";

import type { MarketConfiguration } from "@/config/markets/const";

import mapElevateFacets from "./mapElevateFacets";
import mapElevateProductGroups from "./mapElevateProductGroups";
import mapCustomAttributes from "./mapCustomAttributes";

export default async function getSearchPage(
  market: MarketConfiguration,
  input: SearchPageParams,
  config?: SearchPageBody,
): Promise<Loop54Content> {
  const response = await elevateClient(market).query.searchPage(
    {
      viewId: "production",
      notify:
        process.env.NEXT_PUBLIC_ENVIRONMENT === "prod" &&
        typeof window !== "undefined",
      limit: 60,
      skip: 0,
      presentCustom: mapCustomAttributes(["statuses"], market),
      presentPrices: [
        `NG_${market.code.toLowerCase()}_best`,
        `NG_${market.code.toLowerCase()}_RRP`,
        `NG_${market.code.toLowerCase()}_pricematch`,
        `NG_${market.code.toLowerCase()}_campaign`,
      ],
      priceId: `NG_${market.code.toLowerCase()}_best`,
      ...input,
    },
    {
      primaryList: {
        include: true,
      },
      ...config,
    },
  );

  if (!response.primaryList)
    return {
      items: [],
      filter: [],
      count: 0,
    };

  const { productGroups, facets, totalHits: count } = response.primaryList;

  const items = mapElevateProductGroups({
    productGroups,
    marketConfig: market,
  });
  const filter = mapElevateFacets(facets);

  return { items, filter, count };
}
